import { IBuilder, IIndexable, key, t_key } from 'core-ts-types';
import * as _4 from 'lodash';
import * as moment from 'moment';
import { TimeUtility } from 'utility-ts-type';
import {
  ITermCourseStatusGroup,
  ITermGenericSlotStatusGroup
} from '../strategies/ap_term_course_status_group_strategy';
import {
  APTermStatusConditionalStrategy,
  APTermStatusStrategy,
  IAPTermStatus
} from '../strategies/ap_term_status_strategy';
import { APCourse } from './ap_course_builder';
import { APGenericSlot } from './ap_generic_slot_builder';
import { APPlannedCourse } from './ap_planned_course_builder';
import { APProgramSlot } from './ap_program_slot_builder';

export type time_reference = 'past' | 'present' | 'future';

export interface IAPTermPriorityReg {
  end_ts: string;
  start_ts: string;
  id: number;
  nk: string;
  term: number;
}

export interface IAPTermMeta {
  id: t_key;
  _isTermCompleted: boolean;
  _disablePickTimes: boolean;
}
export interface IAPTermAPI {
  registration_start_dt: string;
  registration_end_dt: string;
  term_start_dt: string;
  term_end_dt: string;
  priority_registration_start_dt?: moment.Moment;
  priority_registration_end_dt?: moment.Moment;
}

/**
 * old name was PlannerTermBuilder
 */
export class APTerm implements IIndexable {
  registration_start_dt: moment.Moment;
  registration_end_dt: moment.Moment;
  priority_registration_start_dt?: moment.Moment;
  priority_registration_end_dt?: moment.Moment;
  term_start_dt: moment.Moment;
  term_end_dt: moment.Moment;
  num_sections: number;
  cat_yr: number;
  rank: number;
  name: string;
  nk: string;
  id: number;
  credit_cap?: number;
  is_past_term: boolean;
  _termStatus: IAPTermStatus;
  _pastCourses: APCourse[];
  _plannedCourses: APPlannedCourse[];
  _plannedCourseGroups: Array<{}>;
  _programSlots: APProgramSlot[];
  _credits: number;
  _showLockAllCourses: boolean = false;
  _showUnLockAllCourses: boolean = false;
  _creditsRange: string;
  _genericSlots: APGenericSlot[];
  _statusGroups: Record<string, ITermGenericSlotStatusGroup>;
  _hasCoursesWithStatus: boolean;
  _isLockedByAdvisorCoursePresent: boolean;
  _hasCreditCapExceeded: boolean;

  constructor(term: Partial<APTerm | IAPTermAPI>) {
    _4.merge(this, term, {
      registration_start_dt: TimeUtility.parseYearMonthDay(term.registration_start_dt as string),
      registration_end_dt: TimeUtility.parseYearMonthDay(term.registration_end_dt as string),
      term_start_dt: TimeUtility.parseYearMonthDay(term.term_start_dt as string),
      term_end_dt: TimeUtility.parseYearMonthDay(term.term_end_dt as string)
    });
    this._termStatus = this.__calculateTermStatus(this);
    this._pastCourses = [];
  }

  private __calculateTermStatus({
    registration_start_dt,
    registration_end_dt,
    term_start_dt,
    term_end_dt,
    priority_registration_start_dt,
    priority_registration_end_dt
  }: APTerm): IAPTermStatus {
    return APTermStatusStrategy.getByKey(
      APTermStatusConditionalStrategy.evaluate(
        {
          registration_start_dt,
          registration_end_dt,
          term_start_dt,
          term_end_dt,
          priority_registration_start_dt,
          priority_registration_end_dt
        },
        'DEFAULT'
      )
    );
  }

  static build(block: Partial<APTerm>): APTerm {
    return new APTerm(block);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/builders/ap_term_builder.ts